import { Link } from "react-router-dom";

export default function Logo({ size = 28, dark = false }) {
  const ringStroke = "#D9481C";
  return (
    <Link to="/" className="flex items-center gap-2.5" data-testid="brand-logo">
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
        <circle cx="16" cy="16" r="15" fill={dark ? "#F4EFE6" : "#16110D"} />
        <path d="M16 8 L16 16 L22 19" stroke={ringStroke} strokeWidth="2.4" strokeLinecap="round" />
        <circle cx="16" cy="16" r="9.5" stroke={ringStroke} strokeWidth="1.4" fill="none" opacity=".5" />
      </svg>
      <span className={`display text-base sm:text-lg tracking-tight whitespace-nowrap ${dark ? "text-cream" : "text-ink"}`}>
        AI Automate Systems<span className="text-rust">.</span>
      </span>
    </Link>
  );
}
